
























import { Vue, Component } from 'vue-property-decorator';
import { CREATE_COA_DIALOG, SHOW_SNACKBAR } from '../../common/constants';
import Product from '../../common/model/Product';
import { ProductCOAPayload } from '../../common/write.types';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';
import productModule from '../../store/modules/product.module';

@Component({
  components: {},
})
export default class CreateCOADialog extends Vue {
  dialog = false;

  updateStatus = false;

  metrcID = '';

  coaPdfFile: File | null = null;

  selectedProductId = '';

  get allProducts(): Array<Product> {
    return productModule.products;
  }

  created():void {
    eventBus.$on(CREATE_COA_DIALOG, this.toggleDialog);
  }

  toggleDialog(): void {
    this.dialog = !this.dialog;
  }

  async createCOA(): Promise<void> {
    if (this.metrcID.length < 7 || !this.selectedProductId || !this.coaPdfFile) {
      eventBus.$emit(SHOW_SNACKBAR, 'Please fill out all required fields for the COA.');
      return;
    }
    if (!brandModule.brand) { return; }
    const coaPayload: ProductCOAPayload = {
      title: this.metrcID,
      productId: this.selectedProductId,
      brandId: brandModule.brand.id,
      pdfName: this.coaPdfFile.name,
    }
    await productModule.createProductCOA({ coaPayload, pdfFile: this.coaPdfFile });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }
    eventBus.$emit(SHOW_SNACKBAR, 'Successfully created COA.');
    this.dialog = false;
  }
}
